// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1R42z","title":"Info_title__2yv_L","selects":"Info_selects__TbZVb","requiredAsterisk":"Info_requiredAsterisk__3K50i"};